import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";
import SignageIcon from "@ps-design-system/icons/Signage/Signage24";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { Links } from "../../constants/links.consts.ts";
import { trackTodoItemClicked } from "../analytics/host-hub-analytics";

type HostHubVatAttentionItemProps = {
  intl: intlFormatPropTypes;
};

const HostHubVatAttentionItem = ({ intl }: HostHubVatAttentionItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);

  const title = intl.formatMessage({
    defaultMessage: "VAT ID needs attention",
    id: "host_hub.todo_list.vat_attention_title",
  });
  const description = intl.formatMessage({
    defaultMessage:
      "We couldn't validate your VAT ID. Review and update your details to avoid fees being applied to your upcoming bookings.",
    id: "host_hub.todo_list.vat_attention_subtitle",
  });

  const handleItemClick = () => {
    trackTodoItemClicked({ parameter: "vat_id_attention", ssoid });
    window.location.assign(Links.AccountTaxes);
  };

  return (
    <Item
      buttonOnClick={handleItemClick}
      description={description}
      icon={<SignageIcon />}
      size="lg"
      title={title}
      variant="critical"
    />
  );
};

export default injectIntl(HostHubVatAttentionItem);
